import React from "react";
import { Door, Key, Permission } from "./types";

interface PermissionTableProps {
  doors: Door[];
  keys: Key[];
  permission: Permission[];
  handlePermissionChange: (idKey: number, idDoor: number, allow: boolean) => void;
  backendUrl: string;
}

const PermissionTable: React.FC<PermissionTableProps> = ({
  doors,
  keys,
  permission,
  handlePermissionChange,
  backendUrl,
}) => {
  return (
    <div className="permission-table">
      {doors.map((door, doorIndex) => (
        <div key={doorIndex} className="permission-table-row">
          {keys.map((key, keyIndex) => (
            <div
              key={keyIndex}
              onClick={() => handlePermissionChange(key.id, door.id, true)}
              className="permission-table-column"
            >
              {permission.some(
                (perm) => perm.idKey === key.id && perm.idDoor === door.id
              ) ? (
                <img
                  src={`${backendUrl}/img/X.svg`}
                  alt="X"
                  style={{ width: "20px", height: "20px" }}
                />
              ) : (
                ""
              )}
            </div>
          ))}
        </div>
      ))}
    </div>
  );
};

export default PermissionTable;
